// Google Analytics 4 — chargé UNIQUEMENT après acceptation du bandeau cookies (conforme CNIL).
// Aucun appel à Google tant que l'utilisateur n'a pas cliqué « Accepter ».
export const GA_ID = "G-8LVBFKP1NQ";
const CONSENT_KEY = "umbo-cookie-consent";
let loaded = false;

export const hasAnalyticsConsent = () =>
  typeof window !== "undefined" && window.localStorage.getItem(CONSENT_KEY) === "accepted";

// Injecte gtag.js et initialise GA4. Idempotent + protégé par le consentement.
export function loadAnalytics() {
  if (loaded || typeof window === "undefined" || !hasAnalyticsConsent()) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // send_page_view:false → on gère nous-mêmes les vues (navigation SPA sans rechargement).
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
  trackPageView(window.location.pathname); // première page vue
}

export function trackPageView(path) {
  if (!loaded || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// Événement de conversion. Pour les leads : name = "generate_lead".
export function trackEvent(name, params = {}) {
  if (!loaded || !window.gtag) return;
  window.gtag("event", name, params);
}
